import styled from 'styled-components';

export const StyledTrashIcon = styled.svg`
    background: none;
    border: none;
    cursor: pointer;
`;
